import { gql } from '@apollo/client'
import { ArrowRightUpIcon, Button } from '@farol-ds/react'
import { Fragment } from 'react'

import { ChooseFrequencyLaterLinksFooter_OfferLockFooterFragment } from './__generated__/choose-frequency-later-links-footer.graphql'
import styles from './choose-frequency-later-links-footer.module.scss'

interface ChooseFrequencyLaterLinksFooterProps {
  footer: ChooseFrequencyLaterLinksFooter_OfferLockFooterFragment
}

export const ChooseFrequencyLaterLinksFooter = ({
  footer,
}: ChooseFrequencyLaterLinksFooterProps) => {
  return (
    <div className={styles.container}>
      {footer.links.map(({ label, url }) => (
        <Fragment key={label + url}>
          <Button kind="plain" asChild>
            <a href={url} target="_blank" rel="noreferrer">
              {label}
              <ArrowRightUpIcon className={styles.footerIcon} />
            </a>
          </Button>
        </Fragment>
      ))}
    </div>
  )
}

ChooseFrequencyLaterLinksFooter.fragments = {
  offerLockFooter: gql`
    fragment ChooseFrequencyLaterLinksFooter_offerLockFooter on OfferLockFooter {
      text
      links {
        label
        url
      }
    }
  `,
}
